<template>
	<v-container grid-list-xl>		
		<v-form v-model="isAddValid">
			<v-layout row wrap>				
				<v-flex lg12>
					<label class="blackLabel">* Status Description:</label>
					<v-text-field label="Status Description" :rules="nameRules" solo v-model="statusDescription" single-line required></v-text-field>
				</v-flex>
				<v-flex lg4>
					<v-switch label="Triggers Notifications" v-model="triggersNotification"></v-switch>
				</v-flex>
				<v-flex lg4>
					<v-switch label="Data Captured" v-model="dataCaptured"></v-switch>
				</v-flex>
				<v-flex lg4>
					<v-switch label="Get Approval" v-model="getApproval"></v-switch>
				</v-flex>
				<v-flex lg4>
					<v-switch label="Approved" v-model="approved"></v-switch>
				</v-flex>
				<v-flex lg4>
					<v-switch label="Denied" v-model="cancel"></v-switch>
				</v-flex>
				<v-flex lg4>
					<v-switch label="Reviewed" v-model="reviewed"></v-switch>
				</v-flex>
				<v-flex lg4>
					<v-switch label="SR Collection" v-model="srCollection"></v-switch>
				</v-flex>
				<v-flex lg4>
					<v-switch label="More Info" v-model="moreInfo"></v-switch>
				</v-flex>
				<v-flex lg4>
					<v-switch label="SR - Received DDC" v-model="receivedDdc"></v-switch>
				</v-flex>			
				<v-flex lg4>
					<v-switch label="SR - Raised" v-model="raised"></v-switch>
				</v-flex>
				<v-flex lg4>
					<v-switch label="SR - Cancelled" v-model="cancelled"></v-switch>
				</v-flex>
				<v-flex lg4>
					<v-switch label="SR - Receipted" v-model="receipted"></v-switch>
				</v-flex>
				<div class="pl-4 pr-1 pb-2 pt-2 buttonHolder">
					<div style="float: right">
						<v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Cancel</v-btn>
						<!--<v-progress-circular indeterminate :width="3" :size="20" v-if="runAdd" color="grey" class="pt-3 loginLoader"></v-progress-circular>-->
						<v-btn color="success" class="text-xs-right" :disabled="!isAddValid" @click.stop="fncAddStatus()">Save</v-btn>
                        <small>* The button will activate once all required fields have been completed</small>
					</div>					
				</div>						
			</v-layout>
		</v-form>	
	</v-container>
</template>

<script>
	import { mapGetters } from 'vuex'; 	
	import Swatches from 'vue-swatches';
	import "vue-swatches/dist/vue-swatches.min.css";
	
	export default {
	  name: 'Settings',
	  components: { Swatches },
	  data () {
			return {
				runAdd: false,
				isAddValid: false,
				statusDescription: '',
                triggersNotification: '',
                dataCaptured: false,
				getApproval: false,
                approved: false,
				//denied: false,
                reviewed: false,
				srCollection: false,
                moreInfo: false,
                receivedDdc: false,
                raised: false,
				cancel: false,
				cancelled: false,
				receipted: false,
				statusOrder: '',
				nameRules: [
					v => !!v || 'Status name is required',				
				],
				orderRules: [
					v => !!v || 'Status order is required',				
				]				
			};
		},		
		methods: {
			fncHideModal () {
				this.$store.commit('hideModal');
			},
			fncAddStatus() {		
				this.runAdd = true;
				this.$store.dispatch({
					type: 'fncAddRfcStatus',
					settings: {
                        statusDescription: this.statusDescription,
                        triggersNotification: this.triggersNotification == true ? 1 : 0,
                        dataCaptured: this.dataCaptured == true ? 1 : 0,
                        getApproval: this.getApproval == true ? 1 : 0,
                        approved: this.approved == true ? 1 : 0,
                        //denied: this.denied == true ? 1 : 0,
                        reviewed: this.reviewed == true ? 1 : 0,
                        srCollection: this.srCollection == true ? 1 : 0,
                        moreInfo: this.moreInfo == true ? 1 : 0,
                        receivedDdc: this.receivedDdc == true ? 1 : 0,
                        raised: this.raised == true ? 1 : 0,
                        cancel: this.cancel == true ? 1 : 0,
                        cancelled: this.cancelled == true ? 1 : 0,
                        receipted: this.receipted == true ? 1 : 0,
                        statusOrder: this.statusOrder
					}
				});
			},
			fncAltBool(bool) {
			    if( bool == true ) {
			        return 1;
				} else {
			        return 0;
				}
			}
		},
		computed: {
			...mapGetters([			
				'objAuthorize',			
				'statusList',
				'globalModalParams',
			])
		}
	}
</script>

<style scoped>
	/*@import '../../assets/css/shared.css'*/
</style>